import { AxiosRequestConfig } from 'axios'

import axios from './axios'

interface IConfig extends AxiosRequestConfig<any> {}

export async function callApi(config: IConfig): Promise<any> {
  const request = async (refreshed?: boolean): Promise<any> => {
    // const tryRefreshToken = async (err: any) => {
    //   try {
    //     const resp = await axios.post('/user/refresh')
    //     return request(true)
    //   } catch (e: any) {
    //     throw err?.response || err
    //   }
    // }

    try {
      const res = await axios.request({
        ...config,
        headers: {
          'Content-Type': 'application/json',
          decompress: false,
          // @ts-ignore
          Authorization: `tma ${window.Telegram.WebApp.initData}`,
          // Authorization: `tma query_id=AAE5bEA_AAAAADlsQD8sUmam&user=%7B%22id%22%3A1061186617%2C%22first_name%22%3A%22Denys%22%2C%22last_name%22%3A%22Matvieiev%22%2C%22username%22%3A%22denismatvieiev%22%2C%22language_code%22%3A%22en%22%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2FiOGw7zRznUp9PS84iO_hAmktbN8ZMHxykb91E7_O1Y8.svg%22%7D&auth_date=1751639618&signature=YPosQf4ml1RsDuvsVEKSewlpxhBy6OwesQYljzEBEmyuB1e-NpcXWKAPoiMdSZnu92v41jezIuw2bTfAOvW4Dg&hash=6bf36aa96b6562a8190e1397a4f39b3cc48bb764fd0664aa4a705e4b5396bfbb`,
          ...config.headers,
        },
      })

      // console.log('res', res)

      return res.data
    } catch (e: any) {
      // if (e?.response?.status === 401 && !config.url?.includes('user/login')) {
      //   if (!refreshed) return tryRefreshToken(e)
      //   console.error('e?.response?.status', e?.response?.status)
      //   throw e?.response || e
      // }

      throw e?.response || e
    }
  }

  return request()
}
